import React from "react";
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";

export default function UsersPage() {
	const url =
		"https://apps.auscomp.au/auth/redirect?redirecturl=" + window.location.origin;
	window.location.assign(url);

	return (
		<div>
			<Header
				color="info"
				brand="Auscomp Cloud Services"
				links={<HeaderLinks dropdownHoverColor="info" />}
				fixed
			/>
			<div>Inter login</div>
		</div>
	);
}
